import { apiRoutes, createStandardCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type OrganizationUnitDto = EntityRecord;
export type OrganizationUnitCreateRequest = EntityCreateRequest;
export type OrganizationUnitUpdateRequest = EntityUpdateRequest;

export const organizationUnitApi: CrudApi<OrganizationUnitDto, OrganizationUnitCreateRequest, OrganizationUnitUpdateRequest> = createStandardCrudApi({
  list: apiRoutes.organizationUnits.list,
  get: apiRoutes.organizationUnits.get,
  create: apiRoutes.organizationUnits.create,
  update: apiRoutes.organizationUnits.update,
  delete: apiRoutes.organizationUnits.delete,
});
